import React from 'react';
import PropTypes from 'prop-types';
import { POPULAR_JOB_ROLES } from 'constants/popularJobLinks';

const DefaultSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        {POPULAR_JOB_ROLES.map((role) => (
          <li key={role.slug}>
            <a href={`/jobs/${role.slug}`}>{role.footerLabel}</a>
          </li>
        ))}
        <li>
          <a href="/jobs/categories">All job categories</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/animators">Animators</a>
      </li>
      <li>
        <a href="/find/videographers">Videographers</a>
      </li>
      <li>
        <a href="/find/graphic-designers">Graphic designers</a>
      </li>
      <li>
        <a href="/find/pitch-deck-designers">Pitch deck designers</a>
      </li>
      <li>
        <a href="/find/social-media-marketers">Social media marketers</a>
      </li>
      <li>
        <a href="/find/digital-marketers">Digital marketers</a>
      </li>
      <li>
        <a href="/find/music-composers">Music composers</a>
      </li>
      <li>
        <a href="/find/music-producers">Music producers</a>
      </li>
      <li>
        <a href="/find/web-designer">Web designer</a>
      </li>
      <li>
        <a href="/find/web-developers">Web developers</a>
      </li>
    </>
  );
};

DefaultSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default DefaultSkills;
